import React, { useState, useEffect, useRef } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

//icons
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import SaveIcon from "@material-ui/icons/Save";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";

import useStyles from "./styles";

import { usePouchDB } from "../../../../components/PouchDB/PouchDBProvider";
import { useSnackbar } from "notistack";

import { Swipeable } from "react-swipeable";

import subforms from "./questions.json";
import PouchDB from "pouchdb-browser";
import PouchDBFind from "pouchdb-find";
import PouchDBAuth from "pouchdb-authentication";
// subforms
import SubFormRadio from "./subforms/radio";
import SubFormNumber from "./subforms/number";
import SubFormNumber06 from "./subforms/number_06";
import SubFormNumber10 from "./subforms/number_10";
import SubFormNumber14 from "./subforms/number_14";
import SubFormNumber15 from "./subforms/number_15";
import SubFormNumber16 from "./subforms/number_16";
import SubFormNumber17 from "./subforms/number_17";
import SubFormNumber19 from "./subforms/number_19";
import SubFormNumber21 from "./subforms/number_21";
import SubformCheckbox from "./subforms/checkbox";
import SubformCheckbox2 from "./subforms/checkbox2";
import SubFormCheckbox3 from "./subforms/checkbox3";
import SubFormRadio2 from "./subforms/subformradio";
import SubFormRadio_16 from "./subforms/subformradio_16";
// import SubFormRadio18 from './subforms/subformradio_18';
import SubFormNumber15New from "./subforms/number_15_new";
import SubFormNumber18New from "./subforms/number_18_new";
import SubFormNumber19New from "./subforms/number_19_new";
import SubFormNumber20New from "./subforms/number_20_new";
import SubFormNumber21New from "./subforms/number_21_new";

import axios from "axios";

import Swal from "sweetalert2";

import validation from "./validation";

import { countAge } from "../pk/validation";

import differenceInCalendarDays from "date-fns/differenceInCalendarDays";

import parseDate from "date-fns/parse";

import { formatString } from "../keluarga";
PouchDB.plugin(PouchDBFind);
PouchDB.plugin(PouchDBAuth, { skip_setup: true });

const API_URL = process.env.REACT_APP_API_DEVELOPMENT_URL;
export const dataFrontend = new PouchDB("frontend");

function PK({
  id,
  wilayah,
  keluarga,
  kb,
  pk,
  mainSlide,
  setPK,
  handleNext,
  handleBack,
  handleDraft,
  handleSegmen,
  handleAnomali,
  setNormalizePK,
  mode,
  no_kk,
  year_doc,
  direction,
}) {
  const classes = useStyles();
  const nextRef = useRef(null);
  const backRef = useRef(null);

  const {
    user: { metadata },
  } = usePouchDB();
  const { enqueueSnackbar } = useSnackbar();

  //action draft
  let valIndex = 0;
  if (
    wilayah.status_draft === 1 &&
    wilayah.pos_draft === 3 &&
    wilayah.subformIndex !== undefined
  ) {
    valIndex = wilayah.subformIndex;
  }

  //action notvalid
  if (wilayah.status_draft === 2 && wilayah.status_sensus === "NotValid") {
    const form_invalid = wilayah.form_invalid;
    if (form_invalid !== "") {
      if (form_invalid === "pk") {
        if (wilayah.index_invalid === "") {
          valIndex = 0;
        } else {
          if (wilayah.index_invalid != 0) {
            valIndex = wilayah.index_invalid - 1;
          } else {
            valIndex = wilayah.index_invalid;
          }
        }
      }
    }
  }

  const [subformIndex, setSubFormIndex] = useState(valIndex);

  const [slide, setSlide] = useState({
    direction: "left",
    in: true,
    navigate: "left",
  });
  const [isSomethingChange, setSomethingChange] = useState(false);

  const [isSubmitting, setSubmitting] = useState(false);

  const [isSaved, setSaved] = useState({
    local: false,
    remote: false,
  });

  const [navigationMode, setNavigationMode] = useState("next");

  // Sebatang Kara
  // const [isSingle, setIsSingle] = useState(
  //   wilayah.jumlah_keluarga === "1" || wilayah.jumlah_keluarga === "01"
  // );

  // useEffect(() => {
  //   isSingleKeluarga();
  // }, []);
  function isSingleKeluarga() {
    const objKeluarga = Object.values(keluarga)[0];
    const objKeluargaFull = Object.values(keluarga);
    // console.log("objKeluarga", objKeluarga);
    // console.log("objKeluargafull", objKeluargaFull);

    // const single =
    //   objKeluarga &&
    //   objKeluarga.sts_kawin !== "2" &&
    //   objKeluarga.sts_kawin !== "3";
    const single = objKeluargaFull && objKeluargaFull.length === 1;
    return single;
  }
  function isCeraiKeluarga() {
    const objKeluarga = Object.values(keluarga)[0];
    // console.log("objKeluarga", objKeluarga);

    const isCeraiStatus =
      objKeluarga &&
      (objKeluarga.sts_kawin === "4" ||
        objKeluarga.sts_kawin === "5" ||
        objKeluarga.sts_kawin === "6");

    const adaAnak = Object.values(keluarga).some(
      (anggota) =>
        (anggota.sts_hubungan === "3" || anggota.sts_hubungan === "4") &&
        anggota.umur < 17 &&
        anggota.sts_kawin === "1"
    );

    const cerai = isCeraiStatus && adaAnak;
    return cerai;
  }

  const [isSingle, setIsSingle] = useState(isSingleKeluarga());
  const [isCerai, setIsCerai] = useState(isCeraiKeluarga());

  const objKeluarga = Object.values(keluarga)[0];
  const [singleParent, setSingleParent] = useState(
    wilayah.year_doc === "2025" &&
      wilayah.jumlah_keluarga !== "1" &&
      wilayah.sts_keluarga === "1" &&
      objKeluarga.jenis_kelamin === "2" &&
      objKeluarga.sts_hubungan === "1"
  );
  const [sessionData, setSessionData] = useState(null);

  // const [tidakBerlaku , setTidakBerlaku] = useState(SubFormRadio = 3)
  // useEffect(() => {
  //   console.log(pk);
  // }, []);

  useEffect(() => {
    let initialPK = {};
    if (wilayah.status_draft === 1) {
      if (wilayah.data_pk.length === 0 || wilayah.data_pk["0"] === null) {
        const sfKeys = Object.keys(subforms);
        for (let i = 0; i < sfKeys.length; i++) {
          initialPK[`${sfKeys[i]}`] = {};
        }
      } else {
        const sfKeys = Object.keys(subforms);
        for (let i = 0; i < sfKeys.length; i++) {
          initialPK[`${sfKeys[i]}`] = wilayah.data_pk[i]
            ? wilayah.data_pk[i]
            : {};
        }
      }
    } else {
      if (mode === "edit") {
        const sfKeys = Object.keys(subforms);
        if (wilayah.data_pk.length === 0 || wilayah.data_pk["0"] === null) {
          const sfKeys = Object.keys(subforms);
          for (let i = 0; i < sfKeys.length; i++) {
            initialPK[`${sfKeys[i]}`] = {};
          }
        } else {
          const sfKeys = Object.keys(subforms);
          for (let i = 0; i < sfKeys.length; i++) {
            initialPK[`${sfKeys[i]}`] = wilayah.data_pk[i]
              ? wilayah.data_pk[i]
              : {};
          }
        }
      } else {
        const sfKeys = Object.keys(subforms);
        for (let i = 0; i < sfKeys.length; i++) {
          initialPK[`${sfKeys[i]}`] = {};
        }
      }
    }

    setPK((cpk) => {
      if (Object.keys(cpk).length > 0) {
        return { ...initialPK, ...cpk };
      }

      return initialPK;
    });

    setNormalizePK((cpk) => {
      if (Object.keys(cpk).length > 0) {
        return { ...initialPK, ...cpk };
      }

      return initialPK;
    });

    // By Me
    // Kondisi ketika satu rumah hanya terdiri 1 orang
    //if (isSingle) {
    // let tgl_lahir = keluarga['01'].tgl_lahir
    // if (countAge(tgl_lahir) >= 60) {
    //     setSubFormIndex(16)
    // }
    //}
    //

    // eslint-disable-next-line react-hooks/exhaustive-deps
    //
  }, []);

  function countAgeMonth(tgl_lahir) {
    const days = differenceInCalendarDays(
      new Date(),
      parseDate(tgl_lahir, formatString, new Date())
    );

    const month = days / 30.41;
    return parseInt(month);
  }

  const ageConvert = (tgl_lahir) => {
    const month = countAgeMonth(tgl_lahir); //days / 365;
    let umur = month / 12;

    // if (month > 720)
    return umur;
  };

  const segmenValidate = () => {
    let newValidate = true;
    let message = "";

    let total = Object.keys(keluarga);

    let enam = false;
    let tujuh = false;
    let sepuluhdualima = false;
    let enampuluh = false;

    for (let i = 1; i <= total.length; i++) {
      let umur = ageConvert(keluarga[i].tgl_lahir);

      if (umur < 6) {
        enam = true;
      }

      if (umur < 7) {
        tujuh = true;
      }

      if (umur >= 10 && umur <= 24) {
        if (keluarga[i].sts_hubungan === "3") {
          sepuluhdualima = true;
        }
      }

      if (umur >= 60) {
        enampuluh = true;
      }
    }
    //

    // Validasi PK No.02
    // if (keluarga[1].sts_kawin === 2) {
    //   if (pk["0202"].jawaban === 3) {
    //     //
    //     console.log("PK No.02 Jawaban 3");

    //     newValidate = false;
    //     message = `PK No.02 Harus Dirubah`;
    //     enqueueSnackbar(message, { variant: "warning" });
    //     return newValidate;
    //   }
    // }

    // if (keluarga[1].sts_kawin !== 2) {
    //   if (pk["0202"].jawaban !== undefined) {
    //     if (pk["0202"].jawaban !== 3) {
    //       //
    //       newValidate = false;
    //       message = `PK No.02 Harus Dirubah`;
    //       enqueueSnackbar(message, { variant: "warning" });
    //       return newValidate;
    //     }
    //   }
    // }

    // if (wilayah.jumlah_keluarga > 1) {
    //   console.log("Debug PK 0203:", pk["0203"]);
    //   if (
    //     !pk["0203"] ||
    //     (pk["0203"].jawaban !== "3" &&
    //       (pk["0203"].jawabanA === undefined || pk["0203"].jawabanA === ""))
    //   ) {
    //     newValidate = false;
    //     message = `PK No.03 Harus Dirubah`;
    //     enqueueSnackbar(message, { variant: "warning" });
    //     return newValidate;
    //   }

    //   if (pk["0209"].jawaban === undefined) {
    //     newValidate = false;
    //     message = `PK No.09 Harus Dirubah`;
    //     enqueueSnackbar(message, { variant: "warning" });
    //     return newValidate;
    //   }

    //   if (pk["0211"].jawaban === undefined) {
    //     newValidate = false;
    //     message = `PK No.11 Harus Dirubah`;
    //     enqueueSnackbar(message, { variant: "warning" });
    //     return newValidate;
    //   }
    // }

    // if (enam) {
    //     if (pk["0213"].jawaban == 3 || pk["0213"].jawaban == undefined) {
    //         newValidate = false
    //         message = `PK No.13 = Tidak Berlaku, Harus Dirubah`
    //         enqueueSnackbar(message, { variant: "warning" })
    //         return newValidate

    //     }
    // } else {
    //     if (pk["0213"].jawaban != undefined && pk["0213"].jawaban != 3) {
    //         newValidate = false
    //         message = `PK No.13 Harus Dirubah`
    //         enqueueSnackbar(message, { variant: "warning" })
    //         return newValidate

    //     }
    // }

    // if (tujuh) {
    //     if (pk["0214"].jawaban == 3 || pk["0214"].jawaban == undefined) {
    //         newValidate = false
    //         message = `PK No.14 = Tidak Berlaku, Harus Dirubah`
    //         enqueueSnackbar(message, { variant: "warning" })
    //         return newValidate

    //     }
    // } else {
    //     if (pk["0214"].jawaban != undefined && pk["0214"].jawaban != 3) {
    //         newValidate = false
    //         message = `PK No.14 Harus Dirubah`
    //         enqueueSnackbar(message, { variant: "warning" })
    //         return newValidate
    //     }
    // }

    // if (sepuluhdualima) {
    //     if (pk["0215"].jawaban == 3 && pk["0216"].jawaban == 3 || pk["0215"].jawaban == undefined && pk["0216"].jawaban == undefined) {
    //         newValidate = false
    //         message = `PK No.15 Atau PK No.16 = Tidak Berlaku, Harus Dirubah`
    //         enqueueSnackbar(message, { variant: "warning" })
    //         return newValidate

    //     }
    // } else {
    //     if (pk["0215"].jawaban != undefined && pk["0215"].jawaban != 3 && pk["0216"].jawaban != undefined && pk["0216"].jawaban != 3) {
    //         newValidate = false
    //         message = `PK No.15 Atau PK No.16 Harus Dirubah`
    //         enqueueSnackbar(message, { variant: "warning" })
    //         return newValidate
    //     }
    // }

    // if (enampuluh) {
    //     if (pk["0217"].jawaban == 3 || pk["0217"].jawaban == undefined) {
    //         newValidate = false
    //         message = `PK No.17 = Tidak Berlaku, Harus Dirubah`
    //         enqueueSnackbar(message, { variant: "warning" })
    //         return newValidate

    //     }
    // } else {
    //     if (pk["0217"].jawaban != undefined && pk["0217"].jawaban != 3) {
    //         newValidate = false
    //         message = `PK No.17 Harus Dirubah`
    //         enqueueSnackbar(message, { variant: "warning" })
    //         return newValidate

    //     }
    // }
    // end Validasi PK No.13 sampai 17

    // Validasi PK No.26 done
    // if (pk["0226"].jawaban === "2") {
    //   if (pk["0227"].jawaban !== undefined) {
    //     //

    //     newValidate = false;
    //     message = `PK No.27 Harus Kosong`;
    //     enqueueSnackbar(message, { variant: "warning" });
    //     return newValidate;
    //   }
    // }
  };

  const handleCheckSegmen = async (event) => {
    const { value } = event.target;
    const targetSegment = parseInt(value);

    const x = parseInt(wilayah.jumlah_keluarga);
    let pkIndex = targetSegment;
    if (x > 1) {
      pkIndex = pkIndex + x - 1;
    }

    if (pkIndex === mainSlide.formIndex) {
      return;
    }

    if (targetSegment === 3) {
      let validate = segmenValidate();
      if (validate === false) {
        return;
      }
      handleSegmen(event, pkIndex);
      return;
    }

    let validate = segmenValidate();

    if (validate === false) {
      //
    } else {
      const { value } = event.target;
      //
      // const x = Object.keys(keluarga).length;
      const x = parseInt(wilayah.jumlah_keluarga);
      //
      if (value) {
        let val = parseInt(value);
        //
        if (x > 1) {
          val > 1 ? (val = val + x - 1) : (val = val);
        }

        let segment_pus = wilayah.pertanyaan_pus || "";
        if ((x === 1 && val === 2) || (segment_pus !== 1 && value === 4)) {
          let message;
          if (val === 2) {
            message = `Data KB tidak Tersedia`;
          } else {
            message = `Data Stunting tidak Tersedia`;
          }

          enqueueSnackbar(message, { variant: "warning" });
        } else {
          //
          handleSegmen(event, val);
        }
      }
    }
  };

  const handleNextSub = () => {
    // if (subformIndex === 25 && pk["0226"] && pk["0226"].jawaban === "2") {
    // if (subformIndex === 25 && pk["0226"] ) {
    //   // return handleNext()
    //   return setSubFormIndex((index) => index + 2);

    //   //
    // } else
    // if (subformIndex === 25 && pk["0226"] && pk["0226"].jawaban === "1") {
    //   return setSubFormIndex((index) => index + 1);
    // }
    // if (isSingle && subformIndex === 6 && pk["0205"]) {
    //   console.log("ini pertanyaan nomor 5");
    // }
    // if (isSingle && pk["0204"]) {
    //   console.log("ini pertanyaan nomor 4, single jadi lompat ke 6");
    //   return setSubFormIndex((index) => index + 1);
    // }

    if (subformIndex === 26 && pk["0227"] && pk["0227"].jawaban[0] === 16) {
      // if (subformIndex === 26 && pk["0227"]) {
      // console.log("jawaban no 27>>>", pk["0227"]);
      return setSubFormIndex((index) => index + 2);
    }
    // if (subformIndex === 28 && pk["0227"] && pk["0227"].jawaban[0] === 16) {

    if (subformIndex === 29 && pk["0230"] && pk["0230"].jawaban === "2") {
      // console.log("ini pertanyaan nomor 30");
      return handleNext();
    } else if (
      subformIndex === 29 &&
      pk["0230"] &&
      pk["0230"].jawaban === "1"
    ) {
      Swal.fire({
        text: "Anda akan kembali ke form wilayah untuk menambah jumlah anggota keluarga yang belum dimasukkan?",
        icon: "warning",
        cancelButtonText: "Batal",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
        confirmButtonColor: "#3085d6",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          return handleBack("WAW");
        } else {
          return setSubFormIndex((index) => index - 1);
        }
      });
    }
    //   //
    // } else if (
    //   subformIndex === 27 &&
    //   pk["0228"] &&
    //   pk["0228"].jawaban === "1"
    // ) {
    //   Swal.fire({
    //     text: "Anda akan kembali ke form wilayah untuk menambah jumlah anggota keluarga yang belum dimasukkan?",
    //     icon: "warning",
    //     cancelButtonText: "Batal",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Ok",
    //     confirmButtonColor: "#3085d6",
    //     showCancelButton: true,
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       return handleBack("WAW");
    //     } else {
    //       return setSubFormIndex((index) => index - 1);
    //     }
    //   });
    // }

    setNavigationMode("next");
    setSlide({
      direction: "right",
      in: false,
      navigate: "right",
    });

    setTimeout(() => {
      // if (isSingle) {
      //     let tgl_lahir = keluarga['01'].tgl_lahir
      //     if (countAge(tgl_lahir) >= 60) {
      //         if (subformIndex === 16) {
      //             setSubFormIndex(index => index + 2);
      //         } else {
      //             setSubFormIndex(index => index + 1);
      //         }
      //     } else {
      //         setSubFormIndex(index => index + 1);
      //     }
      // } else {
      //     setSubFormIndex(index => index + 1);
      // }
      if (isCerai) {
        if (subformIndex === 1) {
          setSubFormIndex((index) => index + 1);
        } else {
          setSubFormIndex((index) => index + 1);
        }
      } else if (isSingle) {
        // Sebatang Kara Mengisi PK No.1
        if (subformIndex === 1) {
          setSubFormIndex((index) => index + 2);
        } else if (subformIndex === 3) {
          setSubFormIndex((index) => index + 2);
        } else if (subformIndex === 13) {
          setSubFormIndex((index) => index + 2);
        } else {
          setSubFormIndex((index) => index + 1);
        }
      } else {
        setSubFormIndex((index) => index + 1);
      }
      // End Sebatang Kara Mengisi PK No.1

      setSlide({
        direction: "left",
        in: true,
      });
    }, 300);
  };

  const handleBackSub = () => {
    if (subformIndex === 0) {
      return handleBack();
    }

    if (subformIndex === 28) {
      // console.log("jawaban no 28>>>", pk["0227"]);

      return setSubFormIndex((index) => index - 2);
    }

    setNavigationMode("back");
    setSlide({
      direction: "left",
      in: false,
      navigate: "left",
    });

    setTimeout(() => {
      if (isSingle) {
        if (subformIndex === 3) {
          setSubFormIndex((index) => index - 2);
        } else if (subformIndex === 5) {
          setSubFormIndex((index) => index - 2);
        } else if (subformIndex === 15) {
          setSubFormIndex((index) => index - 2);
          // } else if (subformIndex === 15) {
          //     setSubFormIndex(index => index - 4);
        } else {
          setSubFormIndex((index) => index - 1);
        }
        // } else if (singleParent && subformIndex === 11) {
        //     setSubFormIndex(index => index - 2)
      } else {
        setSubFormIndex((index) => index - 1);
      }
      // Sebatang Kara Mengisi PK No.1

      setSlide({
        direction: "right",
        in: true,
        navigate: "left",
      });
    }, 300);
    //
  };

  const no = Object.keys(subforms)[subformIndex];
  //

  const getData = async (name, id) => {
    try {
      const data = await axios.get(
        `${API_URL}/auth/getUser?name=${name}&q=${id}&user_key=5848e56474b2baefc07afe94bff01afa`,
        {
          headers: {
            withCredentials: true,
            "Content-Type": "application/json",
            Authorization: "Basic YWRtaW46cGFzc3dvcmQ=",
          },
        }
      );
      return data.data;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const getSession = async () => {
      try {
        // Step 2: login if already logged in
        const localsession = await dataFrontend.get("auth");
        try {
          const newData = await getData(
            localsession.authData.name,
            localsession.authData.id
          );

          const userCtx = {
            name: newData.userProfile.nameProses,
            roles: newData.userProfile.roles,
            id: newData.id,
            ipAddress: newData.ipAddress,
            jsessionid: newData.jsessionid,
            flagFirstLogin: newData.flagFirstLogin,
          };

          const metadata = newData.userProfile;
          return metadata;
        } catch (error) {
          console.error("Error getting data: ", error);
        }
      } catch (e) {
        console.error("Error getting session: ", e);
      }
    };

    getSession()
      .then((metadata) => {
        setSessionData(metadata);
        // console.log(metadata);
      })
      .catch((error) => {
        console.error("Session fetch error:", error);
      });
  }, []);
  const setValue = (e) => {
    if (
      no === "0206" &&
      e?.target.value === "2" &&
      e?.target.name === "jawaban"
    ) {
      //
      // setPK({
      //   ...pk,
      //   [no]: {
      //     ...pk[no],
      //     jawaban: e?.target.value,
      //     jawabanA: [],
      //   },
      // });
      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          [e.target.name]: e.target.value,
        },
      });
    }
    // else if (no === "0208") {
    //   const keluargaKeys = Object.keys(keluarga);
    //   let hasDisabilitas5 = true;

    //   for (let i = 0; i < keluargaKeys.length; i++) {
    //     const key = keluargaKeys[i];
    //     if (keluarga[key].disabilitas.includes(5)) {
    //       hasDisabilitas5 = false;
    //       break;
    //     }
    //   }
    //   if (sessionData?.name.startsWith("opr")) {
    //     if (hasDisabilitas5) {
    //       setPK({
    //         ...pk,
    //         [no]: {
    //           ...pk[no],
    //           jawaban: "1",
    //           jawabanA: "1",
    //         },
    //       });
    //     } else {
    //       setPK({
    //         ...pk,
    //         [no]: {
    //           ...pk[no],
    //           jawaban: e?.target.value,
    //           jawabanA: "",
    //         },
    //       });
    //     }
    //   } else {
    //     if (hasDisabilitas5) {
    //       setPK({
    //         ...pk,
    //         [no]: {
    //           ...pk[no],
    //           jawaban: "1",
    //           jawabanA: "1",
    //         },
    //       });
    //     } else {
    //       setPK({
    //         ...pk,
    //         [no]: {
    //           ...pk[no],
    //           jawaban: "2",
    //           jawabanA: "2",
    //         },
    //       });
    //     }
    //   }

    //   // if (keluarga && Object.keys(keluarga).length && Object.keys(keluarga).some(k => k.disabilitas && k.disabilitas.some(v => v !== "5"))) {
    //   //     setPK({
    //   //         ...pk,
    //   //         [no]: {
    //   //             ...pk[no],
    //   //             jawaban: "1",
    //   //             jawabanA: '1'
    //   //         }
    //   //     });
    //   // } else {
    //   //     setPK({
    //   //         ...pk,
    //   //         [no]: {
    //   //             ...pk[no],
    //   //             jawaban: e?.target.value,
    //   //             jawabanA: ''
    //   //         }
    //   //     });
    //   // }
    // }
    else if (
      no === "0214" &&
      e?.target.name === "jawaban" &&
      (e?.target.value === "6" ||
        e?.target.value === "7" ||
        e?.target.value === "8")
    ) {
      //
      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          jawaban: e?.target.value,
          jawabanA: "2",
        },
      });
    } else if (
      no === "0214" &&
      e?.target.name === "jawaban" &&
      e?.target.value !== "6" &&
      e?.target.value !== "7" &&
      e?.target.value !== "8"
    ) {
      //
      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          jawaban: e?.target.value,
          jawabanA: "",
        },
      });
    } else if (
      no === "0215" &&
      e?.target.name === "jawaban" &&
      (e?.target.value === "6" || e?.target.value === "7")
    ) {
      //
      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          jawaban: e?.target.value,
          jawabanA: "2",
        },
      });
    } else if (
      no === "0215" &&
      e?.target.name === "jawaban" &&
      e?.target.value !== "6" &&
      e?.target.value !== "7"
    ) {
      //
      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          jawaban: e?.target.value,
          jawabanA: "",
        },
      });
    } else if (
      no === "0216" &&
      e?.target.name === "jawaban" &&
      (e?.target.value === "8" || e?.target.value === "9")
    ) {
      //
      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          jawaban: e?.target.value,
          jawabanA: "2",
        },
      });
    } else if (
      no === "0216" &&
      e?.target.name === "jawaban" &&
      e?.target.value !== "8" &&
      e?.target.value !== "9"
    ) {
      //
      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          jawaban: e?.target.value,
          jawabanA: "",
        },
      });
    } else if (no === "0217" && e?.target.name === "jawaban") {
      //
      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          jawaban: e?.target.value,
          jawabanA: "",
        },
      });
    } else if (no === "0219" && e?.target.name === "jawaban") {
      //
      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          jawaban: e?.target.value,
          jawabanA: "",
          // jawabanB: ''
        },
      });
    } else if (no === "0218" && e?.target.name === "jawaban") {
      //
      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          jawaban: e?.target.value,
          jawabanA: "",
          // jawabanB: ''
        },
      });
    } else if (no === "0224" && e?.target.value === "2") {
      //
      const tempNo = Object.keys(subforms)[subformIndex + 1];
      //
      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          [e?.target.name]: e?.target.value,
        },
        [tempNo]: {
          ...pk[tempNo],
          jawaban: [],
        },
      });
    } else if (no === "0226" && e?.target.value === "2") {
      //
      const tempNo = Object.keys(subforms)[subformIndex + 1];
      //
      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          [e?.target.name]: e?.target.value,
        },
        [tempNo]: {
          ...pk[tempNo],
          jawaban: [],
        },
      });
    } else if (no === "0201" && isSingle && e?.target.value !== "0") {
      const temp02 = Object.keys(subforms)[subformIndex + 1];
      const temp03 = Object.keys(subforms)[subformIndex + 2];

      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          [e?.target.name]: e?.target.value,
        },
        [temp02]: {
          ...pk[temp02],
          jawaban: "3",
        },
        [temp03]: {
          ...pk[temp03],
          jawabanA: "0",
          jawabanB: "3",
          jawabanC: "0",
          jawabanD: "0",
        },
      });
    } else if (no === "0209" && isSingle && e?.target.value !== "0") {
      const temp10 = Object.keys(subforms)[subformIndex + 1];
      const temp11 = Object.keys(subforms)[subformIndex + 2];
      const temp12 = Object.keys(subforms)[subformIndex + 3];

      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          [e?.target.name]: e?.target.value,
        },
        [temp10]: {
          ...pk[temp10],
          jawaban: "0",
        },
        [temp11]: {
          ...pk[temp11],
          jawaban: "3",
        },
        [temp12]: {
          ...pk[temp12],
          jawaban: "0",
        },
      });
    } else {
      //
      setPK({
        ...pk,
        [no]: {
          ...pk[no],
          [e?.target.name]: e?.target.value,
        },
      });
    }
    //
    setSomethingChange(true);
  };

  const saveValue = async (normalizeValue) => {
    let period = "2025";
    if (mode === "edit") {
      period = wilayah.periode_sensus;
    }

    //
    const id = `${wilayah.no_kk}${no}`;
    if (!isSomethingChange) {
      if (isSingle && no === "0201" && normalizeValue.Jawab_Pilih !== "") {
        // const temp02 = Object.keys(subforms)[subformIndex + 1];
        const temp03 = Object.keys(subforms)[subformIndex + 2];

        // const incrementId = (id, increment) => {
        //     const parts = id.split(' ');
        //     const prefix = parts[0];
        //     const number = parts[1];

        //     const incrementedNumber = (parseInt(number, 10) + increment).toString().padStart(number.length, '0');

        //     return `${prefix} ${incrementedNumber}`;
        // };

        // const temp02Nomor = incrementId(id, 1);
        // const temp03Nomor = incrementId(id, 2);

        // setNormalizePK((normalizePK) => ({
        //   ...normalizePK,
        //   [no]: {
        //     ...normalizeValue,
        //     _id: id,
        //     No_KK: wilayah.no_kk,
        //     periode_sensus: period,
        //     user_name: metadata.name,
        //   },
        //   [temp02]: {
        //     Pertanyaan:
        //       "Selama 1 bulan terakhir, setiap anggota keluarga menerapkan toleransi beragama",
        //     Jawab_Pilih: "3",
        //     Jawaban_H1: 0,
        //     Jawaban_H2: 0,
        //     No_Pertanyaan: 2,
        //     Lainnya: "",
        //     _id: `${wilayah.no_kk}` + "0202",
        //     No_KK: wilayah.no_kk,
        //     periode_sensus: period,
        //     user_name: metadata.name,
        //   },
        // }));

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp03]: {
            Pertanyaan:
              "Selama 3 bulan terakhir, terdapat konflik antar anggota keluarga berupa:",
            Jawab_Pilih: 0,
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 3,
            Lainnya: "",
            answer: [
              {
                No_Jawaban: 1,
                pilihanpk: "0",
              },
              {
                No_Jawaban: 2,
                pilihanpk: "3",
              },
              {
                No_Jawaban: 3,
                pilihanpk: "0",
              },
              {
                No_Jawaban: 4,
                pilihanpk: "0",
              },
              {
                No_Jawaban: 5,
                pilihanpk: "0",
              },
            ],
            _id: `${wilayah.no_kk}` + "0203",
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
        console.log(temp03, "03");
      } else {
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      }

      if (isSingle && no === "0209" && normalizeValue.Jawab_Pilih !== "") {
        const temp10 = Object.keys(subforms)[subformIndex + 1];
        const temp11 = Object.keys(subforms)[subformIndex + 2];
        const temp12 = Object.keys(subforms)[subformIndex + 3];

        const incrementId = (id, increment) => {
          const parts = id.split(" ");
          console.log("idddddddddd", id);

          if (parts.length < 2) {
            // Handle format yang tidak sesuai
            console.warn(`ID format tidak sesuai: ${id}`);
            // Return ID asli jika formatnya tidak seperti yang diharapkan
            return id;
          }
          const prefix = parts[0];
          const number = parts[1] || "";

          const incrementedNumber = (parseInt(number, 10) + increment)
            .toString()
            .padStart(number.length || 2, "0");

          return `${prefix} ${incrementedNumber}`;
        };

        const temp10Nomor = incrementId(id, 1);
        const temp11Nomor = incrementId(id, 2);
        const temp12Nomor = incrementId(id, 2);

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp10]: {
            Pertanyaan:
              "Selama 1 minggu terakhir, anggota keluarga makan paling sedikit dua kali sehari",
            Jawab_Pilih: "0",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 10,
            Lainnya: "",
            _id: `${wilayah.no_kk}` + "0210",
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: temp11Nomor,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp11]: {
            Pertanyaan:
              "Selama 3 bulan terakhir, terdapat paling sedikit satu anggota keluarga yang mengakses informasi dari media online (internet)",
            Jawab_Pilih: "0",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 11,
            Lainnya: "",
            _id: `${wilayah.no_kk}` + "0211",
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp12]: {
            Pertanyaan:
              "Selama 3 bulan terakhir, terdapat anak berusia 0 - 17 tahun yang mengakses informasi dari media online (internet) dan mendapatkan pendampingan orang tua",
            Jawab_Pilih: "0",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 12,
            Lainnya: "",
            _id: `${wilayah.no_kk}` + "0212",
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      } else {
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      }

      // Kondisi single parent yang memiliki anak
      // if (mode === 'edit' && singleParent && no === '0210' && normalizeValue.Jawab_Pilih !== '') {
      //     const temp11 = Object.keys(subforms)[subformIndex + 1];
      //     setNormalizePK(normalizePK => ({
      //         ...normalizePK,
      //         [no]: {
      //             ...normalizeValue,
      //             _id: id,
      //             No_KK: wilayah.no_kk,
      //             periode_sensus: period,
      //             user_name: metadata.name
      //         },
      //         [temp11]: {}
      //     }));
      // } else {
      //     setNormalizePK(normalizePK => ({
      //         ...normalizePK,
      //         [no]: {
      //             ...normalizeValue,
      //             _id: id,
      //             No_KK: wilayah.no_kk,
      //             periode_sensus: period,
      //             user_name: metadata.name
      //         }
      //     }));
      // }
      // end Kondisi single parent yang memiliki anak

      if (no === "0224" && normalizeValue.Jawab_Pilih === "2") {
        const temp25 = Object.keys(subforms)[subformIndex + 1];
        //
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp25]: {},
        }));
      } else {
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      }

      // if (no === "0227" && normalizeValue.Jawab_Pilih === "2") {
      if (no === "0228") {
        // console.log("masuk 0228");

        const temp25 = Object.keys(subforms)[subformIndex + 1];
        //
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp25]: {},
        }));
      } else {
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      }

      // if (!normalizeValue.Jawab_Pilih || normalizeValue.Jawab_Pilih === "") {
      //   console.log("Validasi gagal: Jawaban belum diisi untuk pertanyaan", no);
      //   enqueueSnackbar("Jawaban wajib diisi", { variant: "warning" });
      //   return;
      // }

      // console.log(
      //   "Validasi berhasil untuk pertanyaan",
      //   no,
      //   "dengan jawaban:",
      //   normalizeValue.Jawab_Pilih
      // );
      return handleNextSub();
    }
    //simpan ke db local
    setSubmitting(true);

    try {
      // const existing = await dataPK.local.get(id);
      // await dataPK.local.put({
      //   _id: id,
      //   _rev: existing._rev,
      //   ...normalizeValue,
      // });

      if (isSingle && no === "0201" && normalizeValue.Jawab_Pilih !== "") {
        // const temp02 = Object.keys(subforms)[subformIndex + 1];
        const temp03 = Object.keys(subforms)[subformIndex + 2];

        // Auto-fill for question 2 is disabled - let user fill it manually
        // setNormalizePK((normalizePK) => ({
        //   ...normalizePK,
        //   [no]: {
        //     ...normalizeValue,
        //     _id: id,
        //     No_KK: wilayah.no_kk,
        //     periode_sensus: period,
        //     user_name: metadata.name,
        //   },
        //   [temp02]: {
        //     Pertanyaan:
        //       "Selama 1 bulan terakhir, setiap anggota keluarga menerapkan toleransi beragama",
        //     Jawab_Pilih: "3",
        //     Jawaban_H1: 0,
        //     Jawaban_H2: 0,
        //     No_Pertanyaan: 2,
        //     Lainnya: "",
        //     _id: `${wilayah.no_kk}` + "0202",
        //     No_KK: wilayah.no_kk,
        //     periode_sensus: period,
        //     user_name: metadata.name,
        //   },
        // }));

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp03]: {
            Pertanyaan:
              "Selama 3 bulan terakhir, terdapat konflik antar anggota keluarga berupa:",
            Jawab_Pilih: 0,
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 3,
            Lainnya: "",
            answer: [
              {
                No_Jawaban: 1,
                pilihanpk: "0",
              },
              {
                No_Jawaban: 2,
                pilihanpk: "3",
              },
              {
                No_Jawaban: 3,
                pilihanpk: "0",
              },
              {
                No_Jawaban: 4,
                pilihanpk: "0",
              },
              {
                No_Jawaban: 5,
                pilihanpk: "0",
              },
            ],
            _id: `${wilayah.no_kk}` + "0203",
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      } else {
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      }

      if (isSingle && no === "0209" && normalizeValue.Jawab_Pilih !== "") {
        const temp10 = Object.keys(subforms)[subformIndex + 1];
        const temp11 = Object.keys(subforms)[subformIndex + 2];
        const temp12 = Object.keys(subforms)[subformIndex + 3];
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp10]: {
            Pertanyaan:
              "Selama 1 minggu terakhir, anggota keluarga makan paling sedikit dua kali sehari",
            Jawab_Pilih: "0",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 10,
            Lainnya: "",
            _id: `${wilayah.no_kk}` + "0210",
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp11]: {
            Pertanyaan:
              "Selama 3 bulan terakhir, terdapat paling sedikit satu anggota keluarga yang mengakses informasi dari media online (internet)",
            Jawab_Pilih: "0",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 11,
            Lainnya: "",
            _id: `${wilayah.no_kk}` + "0211",
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp12]: {
            Pertanyaan:
              "Selama 3 bulan terakhir, terdapat anak berusia 0 - 17 tahun yang mengakses informasi dari media online (internet) dan mendapatkan pendampingan orang tua",
            Jawab_Pilih: "0",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 12,
            Lainnya: "",
            _id: `${wilayah.no_kk}` + "0212",
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      } else {
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      }

      // Kondisi single parent yang memiliki anak
      // if (mode === 'edit' && singleParent && no === '0210' && normalizeValue.Jawab_Pilih !== '') {
      //     const temp11 = Object.keys(subforms)[subformIndex + 1];
      //     setNormalizePK(normalizePK => ({
      //         ...normalizePK,
      //         [no]: {
      //             ...normalizeValue,
      //             _id: id,
      //             No_KK: wilayah.no_kk,
      //             periode_sensus: period,
      //             user_name: metadata.name
      //         },
      //         [temp11]: {}
      //     }));
      // } else {
      //     setNormalizePK(normalizePK => ({
      //         ...normalizePK,
      //         [no]: {
      //             ...normalizeValue,
      //             _id: id,
      //             No_KK: wilayah.no_kk,
      //             periode_sensus: period,
      //             user_name: metadata.name
      //         }
      //     }));
      // }
      // end Kondisi single parent yang memiliki anak

      if (no === "0224" && normalizeValue.Jawab_Pilih === "2") {
        const temp25 = Object.keys(subforms)[subformIndex + 1];
        //
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp25]: {},
        }));
      } else {
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      }

      if (no === "0226" && normalizeValue.Jawab_Pilih === "2") {
        const temp25 = Object.keys(subforms)[subformIndex + 1];
        //
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp25]: {},
        }));
      } else {
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      }
      setSomethingChange(false);
      setSubmitting(false);
      handleNextSub();
    } catch (e) {
      setSubmitting(false);
      if (e.name === "not_found") {
        try {
          // await dataPK.local.put({
          //     _id: id,
          //     type: 'anggota',
          //     ...normalizeValue
          // })

          setSomethingChange(false);
          handleNextSub();
        } catch (e) {
          enqueueSnackbar(e.message, { variant: "error" });
        }
      } else {
        enqueueSnackbar(e.message, { variant: "error" });
      }
    }
  };

  const saveChangeValue = async (normalizeValue) => {
    // console.log("saveChangeValue received:", normalizeValue);
    let period = "2025";
    if (mode === "edit") {
      period = wilayah.periode_sensus;
    }

    //
    const id = `${wilayah.no_kk}${no}`;
    if (!isSomethingChange) {
      if (isSingle && no === "0201" && normalizeValue.Jawab_Pilih !== "") {
        const temp02 = Object.keys(subforms)[subformIndex + 1];
        const temp03 = Object.keys(subforms)[subformIndex + 2];

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp02]: {
            Pertanyaan:
              "Selama 1 bulan terakhir, setiap anggota keluarga menerapkan toleransi beragama",
            Jawab_Pilih: "3",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 2,
            Lainnya: "",
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp02]: {
            Pertanyaan:
              "Selama 1 bulan terakhir, setiap anggota keluarga menerapkan toleransi beragama",
            Jawab_Pilih: "3",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 2,
            Lainnya: "",
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp03]: {
            Pertanyaan:
              "Selama 3 bulan terakhir, terdapat konflik antar anggota keluarga berupa:",
            Jawab_Pilih: 0,
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 3,
            Lainnya: "",
            answer: [
              {
                No_Jawaban: 1,
                pilihanpk: "0",
              },
              {
                No_Jawaban: 2,
                pilihanpk: "3",
              },
              {
                No_Jawaban: 3,
                pilihanpk: "0",
              },
              {
                No_Jawaban: 4,
                pilihanpk: "0",
              },
              {
                No_Jawaban: 5,
                pilihanpk: "0",
              },
            ],
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      } else {
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      }

      if (isSingle && no === "0209" && normalizeValue.Jawab_Pilih !== "") {
        const temp10 = Object.keys(subforms)[subformIndex + 1];
        const temp11 = Object.keys(subforms)[subformIndex + 2];
        const temp12 = Object.keys(subforms)[subformIndex + 3];
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp10]: {
            Pertanyaan:
              "Selama 1 minggu terakhir, anggota keluarga makan paling sedikit dua kali sehari",
            Jawab_Pilih: "0",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 10,
            Lainnya: "",
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp11]: {
            Pertanyaan:
              "Selama 3 bulan terakhir, terdapat paling sedikit satu anggota keluarga yang mengakses informasi dari media online (internet)",
            Jawab_Pilih: "3",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 11,
            Lainnya: "",
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp12]: {
            Pertanyaan:
              "Selama 3 bulan terakhir, terdapat anak berusia 0 - 17 tahun yang mengakses informasi dari media online (internet) dan mendapatkan pendampingan orang tua",
            Jawab_Pilih: "0",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 12,
            Lainnya: "",
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      } else {
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      }

      // Kondisi single parent yang memiliki anak
      // if (mode === 'edit' && singleParent && no === '0210' && normalizeValue.Jawab_Pilih !== '') {
      //     const temp11 = Object.keys(subforms)[subformIndex + 1];
      //     setNormalizePK(normalizePK => ({
      //         ...normalizePK,
      //         [no]: {
      //             ...normalizeValue,
      //             _id: id,
      //             No_KK: wilayah.no_kk,
      //             periode_sensus: period,
      //             user_name: metadata.name
      //         },
      //         [temp11]: {}
      //     }));
      // } else {
      //     setNormalizePK(normalizePK => ({
      //         ...normalizePK,
      //         [no]: {
      //             ...normalizeValue,
      //             _id: id,
      //             No_KK: wilayah.no_kk,
      //             periode_sensus: period,
      //             user_name: metadata.name
      //         }
      //     }));
      // }
      // end Kondisi single parent yang memiliki anak

      if (no === "0224" && normalizeValue.Jawab_Pilih === "2") {
        const temp25 = Object.keys(subforms)[subformIndex + 1];
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp25]: {},
        }));
      } else {
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      }
    }
    //simpan ke db local
    setSubmitting(true);

    try {
      if (isSingle && no === "0201" && normalizeValue.Jawab_Pilih !== "") {
        const temp02 = Object.keys(subforms)[subformIndex + 1];
        const temp03 = Object.keys(subforms)[subformIndex + 2];
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp02]: {
            Pertanyaan:
              "Selama 1 bulan terakhir, setiap anggota keluarga menerapkan toleransi beragama",
            Jawab_Pilih: "3",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 2,
            Lainnya: "",
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp03]: {
            Pertanyaan:
              "Selama 3 bulan terakhir, terdapat konflik antar anggota keluarga berupa:",
            Jawab_Pilih: 0,
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 3,
            Lainnya: "",
            answer: [
              {
                No_Jawaban: 1,
                pilihanpk: "0",
              },
              {
                No_Jawaban: 2,
                pilihanpk: "3",
              },
              {
                No_Jawaban: 3,
                pilihanpk: "0",
              },
              {
                No_Jawaban: 4,
                pilihanpk: "0",
              },
              {
                No_Jawaban: 5,
                pilihanpk: "0",
              },
            ],
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      } else {
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      }

      if (isSingle && no === "0210" && normalizeValue.Jawab_Pilih !== "") {
        const temp10 = Object.keys(subforms)[subformIndex + 1];
        const temp11 = Object.keys(subforms)[subformIndex + 2];
        const temp12 = Object.keys(subforms)[subformIndex + 3];
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp10]: {
            Pertanyaan:
              "Selama 1 minggu terakhir, anggota keluarga makan paling sedikit dua kali sehari",
            Jawab_Pilih: "0",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 10,
            Lainnya: "",
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp11]: {
            Pertanyaan:
              "Selama 3 bulan terakhir, terdapat paling sedikit satu anggota keluarga yang mengakses informasi dari media online (internet)",
            Jawab_Pilih: "0",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 11,
            Lainnya: "",
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));

        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp12]: {
            Pertanyaan:
              "Selama 3 bulan terakhir, terdapat anak berusia 0 - 17 tahun yang mengakses informasi dari media online (internet) dan mendapatkan pendampingan orang tua",
            Jawab_Pilih: "0",
            Jawaban_H1: 0,
            Jawaban_H2: 0,
            No_Pertanyaan: 12,
            Lainnya: "",
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      } else {
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      }

      // Kondisi single parent yang memiliki anak
      // if (mode === 'edit' && singleParent && no === '0210' && normalizeValue.Jawab_Pilih !== '') {
      //     const temp11 = Object.keys(subforms)[subformIndex + 1];
      //     setNormalizePK(normalizePK => ({
      //         ...normalizePK,
      //         [no]: {
      //             ...normalizeValue,
      //             _id: id,
      //             No_KK: wilayah.no_kk,
      //             periode_sensus: period,
      //             user_name: metadata.name
      //         },
      //         [temp11]: {}
      //     }));
      // } else {
      //     setNormalizePK(normalizePK => ({
      //         ...normalizePK,
      //         [no]: {
      //             ...normalizeValue,
      //             _id: id,
      //             No_KK: wilayah.no_kk,
      //             periode_sensus: period,
      //             user_name: metadata.name
      //         }
      //     }));
      // }
      // end Kondisi single parent yang memiliki anak

      if (no === "0224" && normalizeValue.Jawab_Pilih === "2") {
        const temp25 = Object.keys(subforms)[subformIndex + 1];
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
          [temp25]: {},
        }));
      } else {
        setNormalizePK((normalizePK) => ({
          ...normalizePK,
          [no]: {
            ...normalizeValue,
            _id: id,
            No_KK: wilayah.no_kk,
            periode_sensus: period,
            user_name: metadata.name,
          },
        }));
      }
      setSomethingChange(false);
      setSubmitting(false);
    } catch (e) {
      setSubmitting(false);
      if (e.name === "not_found") {
        try {
          setSomethingChange(false);
        } catch (e) {
          enqueueSnackbar(e.message, { variant: "error" });
        }
      } else {
        enqueueSnackbar(e.message, { variant: "error" });
      }
    }
  };

  const backRadio = (cekberlaku) => {
    if (cekberlaku === false) {
      handleBackSubRadio();
    }
  };

  const handleBackSubRadio = () => {
    if (subformIndex === 0) {
      return handleBack();
    }

    setNavigationMode("back");
    setSlide({
      direction: "left",
      in: false,
      navigate: "left",
    });
    setTimeout(() => {
      if (isSingle) {
        if (subformIndex === 3) {
          setSubFormIndex((index) => index - 3);
        } else if (subformIndex === 11) {
          setSubFormIndex((index) => index - 4);
        } else if (subformIndex === 15) {
          setSubFormIndex((index) => index - 4);
        } else {
          setSubFormIndex((index) => index - 1);
        }
      } else {
        setSubFormIndex((index) => index - 1);
      }
      // Sebatang Kara Mengisi PK No.1

      setSlide({
        direction: "right",
        in: true,
        navigate: "left",
      });
    }, 300);
  };
  //

  // subform aktif
  const form = subforms[no];
  const value = pk[no];

  return (
    <>
      <Swipeable
      // trackMouse={true}
      // onSwipedRight={(e) => {

      //     if (backRef) {
      //         backRef.current.click()
      //     }
      // }}
      // onSwipedLeft={(e) => {
      //     if (nextRef) {

      //         nextRef.current.click();
      //     }
      // }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.textCenter}>
            <Typography variant="h5" component="h1">
              {mode === "edit"
                ? `Edit Form Pembangunan Keluarga`
                : "Form Pembangunan Keluarga"}
            </Typography>
            {/* {mode === 'edit' && <Typography>No KK: {no_kk}</Typography>} */}
          </Grid>

          <Grid item xs className={classes.textLeft}>
            {(mode === "edit" &&
              wilayah.status_draft &&
              wilayah.status_draft === "1") ||
            (Object.hasOwn(wilayah, "submit") && wilayah.submit === false) ? (
              <>
                {" "}
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleDraft("local", 3, subformIndex)}
                  disabled={isSubmitting.local || isSaved.local}
                  style={{ marginRight: "10px" }}
                >
                  <SaveIcon className={classes.iconLeft} /> Save as Draft{" "}
                </Button>{" "}
              </>
            ) : (
              <></>
            )}

            {mode === "edit" &&
            (wilayah.status_draft === undefined ||
              wilayah.status_draft === "2") ? (
              <>
                <FormControl variant="outlined">
                  <Select
                    id=""
                    value=""
                    name="segmen"
                    onChange={handleCheckSegmen}
                    displayEmpty
                  >
                    <MenuItem value=""> Segmen </MenuItem>
                    <MenuItem value="0"> Wilayah </MenuItem>
                    <MenuItem value="1"> Keluarga </MenuItem>
                    <MenuItem value="2"> KB </MenuItem>
                    <MenuItem value="3"> PK </MenuItem>
                    {/* <MenuItem value="4"> Stunting </MenuItem> */}
                  </Select>
                </FormControl>
              </>
            ) : (
              <></>
            )}

            {mode !== "edit" ? (
              <>
                {" "}
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleDraft("local", 3, subformIndex)}
                  disabled={isSubmitting.local || isSaved.local}
                >
                  <SaveIcon className={classes.iconLeft} /> Save as Draft{" "}
                </Button>{" "}
              </>
            ) : (
              <></>
            )}
          </Grid>

          <Grid item>
            {mode === "edit" && wilayah.status_sensus === "Anomali" ? (
              <>
                {" "}
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleAnomali("local", 1)}
                  disabled={isSubmitting.local || isSaved.local}
                >
                  <AssignmentTurnedInIcon /> Anomali Terkonfirmasi{" "}
                </Button>{" "}
              </>
            ) : (
              <></>
            )}
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            {/* {} */}
            <Slide direction={slide.direction} in={slide.in}>
              <div className={classes.slideContent}>
                {value && (
                  <>
                    {form.tipe === "radio" && (
                      <SubFormRadio
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        pk={pk}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        setIsSingle={setIsSingle}
                        isSingle={isSingle}
                        setSingleParent={setSingleParent}
                        singleParent={singleParent}
                        direction={slide}
                        backRadio={backRadio}
                        wilayah={wilayah}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.tipe === "number" && (
                      <SubFormNumber
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        pk={pk}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        wilayah={wilayah}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.tipe === "checkbox" && (
                      <SubformCheckbox
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        pk={pk}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.tipe === "checkbox2" && (
                      <SubformCheckbox2
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        pk={pk}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.tipe === "checkbox3" && (
                      <SubFormCheckbox3
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        pk={pk}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.tipe === "subformradio" && (
                      <SubFormRadio2
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        pk={pk}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.tipe === "number_06" && (
                      <SubFormNumber06
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        pk={pk}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        setIsSingle={setIsSingle}
                        isSingle={isSingle}
                        direction={slide}
                        backRadio={backRadio}
                        wilayah={wilayah}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.tipe === "number_10" && (
                      <SubFormNumber10
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        pk={pk}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        setIsSingle={setIsSingle}
                        isSingle={isSingle}
                        direction={slide}
                        backRadio={backRadio}
                        wilayah={wilayah}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.tipe === "number_14" && (
                      <SubFormNumber06
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        pk={pk}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        setIsSingle={setIsSingle}
                        isSingle={isSingle}
                        direction={slide}
                        backRadio={backRadio}
                        wilayah={wilayah}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.tipe === "number_15" && (
                      <SubFormNumber15New
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        pk={pk}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        setIsSingle={setIsSingle}
                        isSingle={isSingle}
                        direction={slide}
                        backRadio={backRadio}
                        wilayah={wilayah}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.tipe === "number_16" && (
                      <SubFormRadio_16
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        pk={pk}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.tipe === "number_17" && (
                      <SubFormNumber14
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        pk={pk}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        setIsSingle={setIsSingle}
                        isSingle={isSingle}
                        direction={slide}
                        backRadio={backRadio}
                        wilayah={wilayah}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.no === "18.1" && (
                      <SubFormNumber18New
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        pk={pk}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        setIsSingle={setIsSingle}
                        isSingle={isSingle}
                        direction={slide}
                        backRadio={backRadio}
                        wilayah={wilayah}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.tipe === "number_19" && (
                      <SubFormNumber19New
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        pk={pk}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        setIsSingle={setIsSingle}
                        isSingle={isSingle}
                        direction={slide}
                        backRadio={backRadio}
                        wilayah={wilayah}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.tipe === "number_20" && (
                      <SubFormNumber20New
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        pk={pk}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        setIsSingle={setIsSingle}
                        isSingle={isSingle}
                        direction={slide}
                        backRadio={backRadio}
                        wilayah={wilayah}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}

                    {form.tipe === "number_21" && (
                      <SubFormNumber21New
                        id={no}
                        value={value}
                        setValue={setValue}
                        saveValue={saveValue}
                        kb={kb}
                        pk={pk}
                        handleNextSub={handleNextSub}
                        handleBackSub={handleBackSub}
                        navigationMode={navigationMode}
                        subformIndex={subformIndex}
                        form={form}
                        keluarga={keluarga}
                        setIsSingle={setIsSingle}
                        isSingle={isSingle}
                        direction={slide}
                        backRadio={backRadio}
                        wilayah={wilayah}
                        saveChangeValue={saveChangeValue}
                        isSubmitting={isSubmitting}
                      />
                    )}
                  </>
                )}
              </div>
            </Slide>
          </Grid>
          {/* <Grid item xs>
                    <Button
                        ref={backRef}
                        // disabled={!isSomethingChange || isSubmitting}
                        onClick={handleBackSub}><ChevronLeft className={classes.iconLeft} /> Sebelumnya </Button>
                </Grid> */}

          {/* <Grid item xs>
                    {
                        mode === "edit" && wilayah.status_draft && wilayah.status_draft === '1' ?
                            <> <Button
                                color="primary"
                                variant="contained"
                                onClick={handleDraft('local', 3, subformIndex)}
                                disabled={isSubmitting.local || isSaved.local}
                            >
                                <SaveIcon className={classes.iconLeft} /> Save as Draft </Button> </> : <></>
                    }

                    {
                        mode === "edit" && (wilayah.status_draft == undefined || wilayah.status_draft === '2') ?
                            <>
                                <FormControl
                                    variant="outlined">
                                    <Select
                                        id=""
                                        value=""
                                        name="segmen"
                                        onChange={handleCheckSegmen}
                                        displayEmpty
                                    >
                                        <MenuItem value=""> Segmen </MenuItem>
                                        <MenuItem value="0"> Wilayah </MenuItem>
                                        <MenuItem value="1"> Keluarga </MenuItem>
                                        <MenuItem value="2"> KB </MenuItem>
                                        <MenuItem value="3"> PK </MenuItem>
                                    </Select>
                                </FormControl>
                            </> : <></>
                    }

                    {
                        mode !== "edit" ?
                            <> <Button
                                color="primary"
                                variant="contained"
                                onClick={handleDraft('local', 3, subformIndex)}
                                disabled={isSubmitting.local || isSaved.local}
                            >
                                <SaveIcon className={classes.iconLeft} /> Save as Draft </Button> </> : <></>
                    }
                </Grid> */}

          {/* <Grid item>
                    {isSubmitting && <CircularProgress size={14} />}
                    <Button
                        ref={nextRef}
                        form={no}
                        disabled={isSubmitting}
                        type="submit">{(subformIndex >= 31 || (subformIndex === 30 && pk["0231"] && pk["0231"].jawaban === "2")) ? 'Selesai' : 'Selanjutnya'} <ChevronRight className={classes.iconRight} /></Button>
                </Grid> */}
        </Grid>
      </Swipeable>
    </>
  );
}

export default PK;
